import Axios from "axios";
import Authorization from './auth';
import { executeCall } from "./utils";

const crudder = (domain, resource, withAuth = true) => {
    const url = `${domain}/${resource}`;

    const getHeaders = () => withAuth ? Authorization() : {};

    return {
        get options() {
            return { headers: getHeaders(), url };
        },
        setupIntent: () => executeCall(() => Axios.get(url + '/setup-payment', { headers: getHeaders() })),
        paymentMethods: () => executeCall(() => Axios.get(url + '/payment-methods', { headers: getHeaders() })),
        deletePaymentMethod: (data) => executeCall(() => Axios.post(url + '/delete-payment-method', data, { headers: getHeaders() })),
    };
};


export default crudder;